import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { useBrokerDetailsStore } from '../../../state/brokerDetailsStore';

export const SameAsContactAddressField = () => {
    const value = useBrokerDetailsStore((s) => s.sameAsContactAddress);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    return (
        <YesNoToggleButton
            id='sameAsContactAddress'
            value={value}
            onItemClick={(e) => updateFields({ sameAsContactAddress: e.itemData?.id === 'Yes' })}
            label='Same as Contact Address?'
            labelSize={ToggleButtonLabelSize.Medium}
        />
    );
};
